// считается Fs

import { IChartDataOrbit } from "../interfaces";

export function estimateOrbitSamplingRateHz(orbit: IChartDataOrbit | undefined): number | null {
  if (!orbit) {
    return null;
  }
  const n = orbit.xData?.length ?? 0;
  const yLen = orbit.yData?.length ?? 0;
  if (!n || n !== yLen) {
    return null;
  }

  const dataMs = orbit.param3DataMs;
  if (dataMs != null && Number.isFinite(dataMs) && dataMs > 0) {
    const fs = (1000 * n) / dataMs;
    return Number.isFinite(fs) && fs > 0 ? fs : null;
  }

  if (orbit.rangeType !== 2) {
    return null;
  }
  const param3 = Number(orbit.param3);
  const fRot = orbit.rotationFrequencyHz;
  if (!Number.isFinite(param3) || param3 <= 0) {
    return null;
  }
  if (fRot == null || !Number.isFinite(fRot) || fRot <= 0) {
    return null;
  }
  const fs = (n / param3) * fRot;
  return Number.isFinite(fs) && fs > 0 ? fs : null;
}
